import { IMoney } from '../../types/IMoney';

/**
 * Quantity state of an invoice item against the ordered quantity. Only over-invoicing is a deviation;
 * the other two are neutral hints.
 */
export enum InvoicedQuantityStatus {
    PARTIALLY_INVOICED = 'PARTIALLY_INVOICED',
    FULLY_INVOICED = 'FULLY_INVOICED',
    OVER_INVOICED = 'OVER_INVOICED',
}

/**
 * One compared field. The backend omits null members (production Jackson inclusion is NON_NULL), so
 * every optional member is declared with `?` and not as `| null`.
 */
export interface IInvoiceValueComparisonDto<T> {
    invoiceValue?: T;
    orderValue?: T;
    isDifferent: boolean;
}

export interface IInvoiceItemQuantityComparisonDto {
    /** Signed as it enters the cumulative quantity: negative on a credit note. */
    invoiceQuantity: number;
    orderedQuantity: number;
    cumulativeInvoicedQuantity: number;
    status: InvoicedQuantityStatus;
    isDifferent: boolean;
}

export interface IInvoiceItemOrderComparisonDto {
    invoiceItemId: string;
    invoicePosition: number;
    linkedToOrder: boolean;
    orderId?: string;
    orderItemId?: number;
    orderItemPosition?: number;
    price?: IInvoiceValueComparisonDto<IMoney>;
    priceQuantity?: IInvoiceValueComparisonDto<number>;
    currency?: IInvoiceValueComparisonDto<string>;
    taxInPercent?: IInvoiceValueComparisonDto<number>;
    supplierArticleNumber?: IInvoiceValueComparisonDto<string>;
    unit?: IInvoiceValueComparisonDto<string>;
    quantity?: IInvoiceItemQuantityComparisonDto;
    isDifferent: boolean;
}

export interface IInvoiceOrderComparisonDto {
    invoiceId: string;
    creditNote: boolean;
    linkedToOrder: boolean;
    isDifferent: boolean;
    items: IInvoiceItemOrderComparisonDto[];
}
